import { render, staticRenderFns } from "./AvatarUploader.vue?vue&type=template&id=34051874&scoped=true"
import script from "./AvatarUploader.vue?vue&type=script&lang=js"
export * from "./AvatarUploader.vue?vue&type=script&lang=js"
import style0 from "./AvatarUploader.vue?vue&type=style&index=0&id=34051874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34051874",
  null
  
)

export default component.exports